import { ArrowBack } from "@mui/icons-material";
import { Button } from "components/ui";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetForgetPass,
  resetResetPass,
} from "store/slices/admin/session/auth";

const BackToLoginBtn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { forgotPass, resetPass } = useSelector((state) => state.auth);

  return (
    <Button
      size={"lg"}
      onClick={() => {
        if (forgotPass) {
          dispatch(resetForgetPass());
        }
        if (resetPass) {
          dispatch(resetResetPass());
        }
        navigate("/");
      }}
      className="w-full"
    >
      <ArrowBack />
      <p>Back To Login</p>
    </Button>
  );
};

export default BackToLoginBtn;
